module.exports = __webpack_public_path__ + "static/img/yy.2fa4a56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yy.png
// module id = 5Uf5
// module chunks = 1